import { CommonModule } from '@angular/common';
import { Component, Input, input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppstateService } from '../../services/appstate.service';
import { AuthServiceService } from '../../services/auth-service.service';

@Component({
  selector: 'app-side-nav',
  imports: [RouterModule,CommonModule],
  templateUrl: './side-nav.component.html',
  styleUrl: './side-nav.component.scss'
})
export class SideNavComponent {
  isExpanded : boolean = false;
  user : any;
  constructor(private appstateService: AppstateService,private _authService : AuthServiceService) {
    this.user = _authService.getUserSession();
  }
  
  expandSideBar(){
    this.isExpanded = !this.isExpanded;
    this.appstateService.isAppSideBar.next(this.isExpanded);
  }
}
